// extracted by mini-css-extract-plugin
export default {"start":"start_start__wwGpu","start__profileImg":"start_start__profileImg__2MmI1","title":"start_title__zExpX","row":"start_row__zRRET","column":"start_column__fbnpl"};